import { Tooltip } from "antd";
import mergeClassNames from "common/mergeClassNames";

interface ISubsumedBadgeProps {
    // The record it was merged into, named in the tooltip.
    survivorId?: string | null;
    className?: string;
}

// PRE-2837: marks a record deduplication flagged as subsumed by a survivor in its own dataset. It
// is still in its dataset, but left out of duplicate searches until a steward retires or restores it.
export default function SubsumedBadge({ survivorId, className }: ISubsumedBadgeProps) {
    return (
        <Tooltip title={`Merged into record ${survivorId || "(unknown)"}; retire or restore it from the schema's review queue.`}>
            <span
                className={mergeClassNames(
                    "inline-flex items-center rounded-full border border-gray-300 bg-gray-100 px-2 py-0.5 text-[11px] font-medium uppercase tracking-wide text-gray-600",
                    className,
                )}
                data-testid="subsumed-badge"
            >
                Subsumed
            </span>
        </Tooltip>
    );
}

// The survivor a record (as the dataset lists it, or as search returns it) was flagged as
// subsumed into; null when it is not flagged.
export function subsumedInto(record: any): string | null {
    if (!record) {
        return null;
    }
    if (record._dispositionStatus === "SUBSUMED") {
        return record._survivorId || "";
    }
    const disposition = record.__disposition;
    // A flag edited away since (another version) is stale.
    const current = disposition && (!Number.isInteger(disposition.version) || disposition.version === record.version);
    return disposition && current && disposition.status === "SUBSUMED" && disposition.reason === "DUPLICATE" && record.deleted !== true ? disposition.survivorId || "" : null;
}
